import React, { useState } from 'react';
import Sidebar from './SideBar';
import MainContent from './MainContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer } from 'react-toastify';
import { Routes, Route } from 'react-router-dom';

const AdminPanel = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="flex flex-col h-screen navbar-link">
      <div className="flex flex-grow">
        <Sidebar isOpen={isOpen} />
        <ToastContainer />
        <div className={`flex-1 flex flex-col md:max-w-screen-xl lg:max-w-screen-2xl transition-all duration-300 ${isOpen ? 'ml-0' : 'md:ml-56 -ml-64 lg:ml-72'}`}>
          <header className="text-white p-4 flex justify-end items-center w-full md:hidden">
            <button onClick={toggleSidebar} className="text-black">
              <FontAwesomeIcon icon={faBars} />
            </button>
          </header>
          <Routes>
            <Route path="/*" element={<MainContent />} />
          </Routes>
        </div>
      </div>
     {/* Footer Section with Green Emerald Branding */}
      <footer className=" text-[#16bab1] text-end p-6  font-medium py-4 mt-auto">
        <p className="text-sm">
          Designed and Developed by <span className="font-bold  ">Green Emerald Branding Agency</span>
        </p>
        
      </footer>
    </div>
  );
};

export default AdminPanel;
